export const MP_LABEL = { wb: 'WB', ozon: 'Ozon', yandex: 'Yandex' };

export function accountsUrl(marketplace) {
  if (marketplace === 'ozon') return '/mswb/ozon-accounts';
  if (marketplace === 'yandex') return '/mswb/yandex-accounts';
  return '/mswb/wb-accounts';
}

export function mpWarehousesUrl() {
  return '/ms-assortment/warehouses';
}

export function asList(data) {
  if (Array.isArray(data?.rows)) return data.rows;
  if (Array.isArray(data?.items)) return data.items;
  if (Array.isArray(data?.bindings)) return data.bindings;
  if (Array.isArray(data)) return data;
  return [];
}

export function storeOptions(rows) {
  return (Array.isArray(rows) ? rows : [])
    .map((s) => ({ id: String(s.id), name: s.name || String(s.id) }))
    .filter((s) => s.id);
}

export function sameIdList(a, b) {
  const left = [...(Array.isArray(a) ? a : [])].map(String).sort();
  const right = [...(Array.isArray(b) ? b : [])].map(String).sort();
  return left.length === right.length && left.every((id, i) => id === right[i]);
}

export function mergeSelectedOptions(options, ids, fallbackPrefix = 'id') {
  const byId = new Map((options || []).map((o) => [String(o.id), o]));
  for (const raw of ids || []) {
    const id = String(raw);
    if (!byId.has(id)) byId.set(id, { id, name: `${fallbackPrefix} ${id}` });
  }
  return [...byId.values()];
}

export function forcedItems(row) {
  return Array.isArray(row?.forced) ? row.forced : [];
}

export function forcedBindingsCount(row) {
  return forcedItems(row).filter((item) => item != null && item.forced_stock != null && String(item.forced_stock) !== '').length;
}

export function parseForcedValue(value) {
  if (value == null || value === '') return null;
  const num = Number(value);
  return Number.isFinite(num) ? num : null;
}

export function productLinks(row) {
  return Array.isArray(row?.links) ? row.links : [];
}

export function productBroadcastOn(row) {
  return productLinks(row).some((link) => !!link.enabled);
}

export function productHasLinks(row) {
  return productLinks(row).length > 0;
}
